import { memo, useRef } from 'react';
import { useShare } from '../hooks/useShare.mjs';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/**
 * @description https://wiki.navercorp.com/pages/viewpage.action?pageId=256032483 을 참고해주세요.
 * @warning **Attribute 방식은 동작하지 않습니다.** data-* 방식은 리액트 props 객체 불변성을 위해 동작하지 않게 설계되었습니다. `elementConfig`를 통해 등록해주세요.
 */
const ShareButton = /*#__PURE__*/memo(_ref => {
  let {
    profile,
    env,
    pluginConfig,
    elementConfig,
    children,
    fallback = null,
    ...props
  } = _ref;
  const ref = useRef(null);
  const isLoaded = useShare({
    profile,
    env,
    pluginConfig,
    elementConfig,
    ref
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!isLoaded && fallback, /*#__PURE__*/jsx("button", {
      ...props,
      ref: ref,
      "data-style": elementConfig?.style,
      style: {
        display: isLoaded ? 'block' : 'none'
      },
      className: `naver-splugin ${props.className}`,
      children: children
    })]
  });
});

export { ShareButton };
